// extracted by mini-css-extract-plugin
export default {"varSpDown3":"0.25rem","innerAlign":"innerAlign--70df9"};